import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map, timeout } from 'rxjs/operators'
import { environment } from 'src/environments/environment'
import { UserDetailsResponse, UserData } from './manager-profile.types'
import { HttpClient, HttpResponse } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class ManagerService {
  constructor(private http: HttpClient) {}
  server = `${environment.server}`
  getManager = this.server + '/api/getManagerByMobile'

  getManagerByMobile(mobile: string): Observable<UserData> {
    return this.http
      .get<UserDetailsResponse>(this.getManager + '/' + mobile, {
        observe: 'response',
      })
      .pipe(
        timeout(3000),
        map((userDetailsResponse: HttpResponse<UserDetailsResponse>) => {
          if (
            userDetailsResponse &&
            userDetailsResponse.body &&
            userDetailsResponse.body.data
          ) {
            return userDetailsResponse.body.data
          } else {
            throw Error(
              'Unable to fetch this user, Please check the number again'
            )
          }
        })
      )
  }
}
